'use client'

import { cn } from '@/lib/utils'

export interface ChipOption {
  value: string
  label: string
}

interface ChipGroupProps {
  label?: string
  options: ChipOption[]
  value: string | null
  onChange: (value: string) => void
  size?: 'sm' | 'md'
}

export function ChipGroup({ label, options, value, onChange, size = 'sm' }: ChipGroupProps) {
  return (
    <div>
      {label && <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-neutral-500">{label}</p>}
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = value === opt.value
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={cn(
                'rounded-full border font-medium transition-all',
                size === 'md' ? 'px-4 py-2 text-sm' : 'px-3 py-1.5 text-xs',
                active
                  ? 'border-crimson-500/60 bg-crimson-600/20 text-white'
                  : 'border-white/10 bg-white/5 text-neutral-300 hover:border-white/25 hover:text-white'
              )}
            >
              {opt.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
